import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';
import classes from '../../../_common/Tables/styles.module.scss';
import Loader from '../../../_common/Loader/Loader';
import Pagination from '../../../_common/Pagination/Pagination';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit.svg';
import { ReactComponent as EyeIcon } from '../../../../assets/icons/eye.svg';

function PatientTable({
  data, header, className = '', page, limit, totalPage, onChange, hasEditPermission,
}) {
  const [loading, setLoading] = useState(false);
  const tdClass = [classes.td];

  if (className) tdClass.push(className);

  const onChangeLoading = async (path, count) => {
    setLoading(true);
    await onChange(path, count);
    setLoading(false);
  };

  return (
    !data.length && !loading
      ? <div className={classes.notResult}>No Data Found</div>

      : (
        <div className={classes.script_loader_wrapper}>
          { loading && <Loader className={classes.loader_wrapper} />}

          <div className={classes.table_wrapper}>
            <div className={classes.table__border}>
              <table className={classes.table}>

                <thead className={classes.thead}>
                  <tr className={classes.tr}>
                    {header.map((h) => (
                      <th className={classes.th} key={h}>{h}</th>
                    ))}
                  </tr>
                </thead>

                <tbody className={classes.tbody}>
                  {data.map((d) => (
                    <tr className={classes.tr} key={d.id}>
                      <td className={classes.td}>
                        <NavLink className={classes.patient_transition} to={`/patients/${d.id}`}>
                          {(d.firstName || d.lastName) ? `${d.firstName} ${d.lastName}` : '-'}
                        </NavLink>
                      </td>

                      {d.dob ? (
                        <td className={classes.td}>
                          {moment(d.dob).format('MM/DD/YYYY')}
                        </td>
                      ) : <td className={classes.td}> - </td>}

                      {d.phone ? (
                        <td className={classes.td}>
                          {d.phone}
                        </td>
                      ) : <td className={classes.td}> - </td>}

                      {(!_.isEmpty(_.compact([d.addressStreet, d.addressCity, d.addressState, d.addressZipCode]))) ? (
                        <td className={classes.td}>
                          {_.compact([d.addressStreet, d.addressCity, d.addressState, d.addressZipCode]).join(', ')}
                        </td>
                      ) : <td className={classes.td}> - </td>}

                      <td className={tdClass.join(' ')}>
                        <div>
                          <NavLink to={`/patients/${d.id}`}>
                            <EyeIcon />
                          </NavLink>

                          {hasEditPermission && (
                            <NavLink to={`/patients/${d.id}/edit`}>
                              <EditIcon />
                            </NavLink>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination page={page} limit={limit} totalPage={totalPage} onChange={onChangeLoading} />
        </div>
      )
  );
}

PatientTable.propTypes = {
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  totalPage: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
};

export default PatientTable;
